export default [
  {
    path: '/businessProgress', // 会员
    name: 'businessProgress',
    component: () => {
      return import(
        /* webpackChunkName: "businessProgress" */ '@/views/businessprogress/index.vue'
      )
    }
  }
]
